import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=a8f280f4&scoped=true&"
import script from "./ContactPersons.vue?vue&type=script&lang=js&"
export * from "./ContactPersons.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersons.vue?vue&type=style&index=0&id=a8f280f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f280f4",
  null
  
)

export default component.exports